const moment = require("moment");
import { Report_G11_service } from "./../services/reportG11.service"
import { Loading } from 'element-ui';
const state = {
  service_rate:['หน่วย: บาท/Kbps','หน่วย: บาท/Mbps'],
  text_service_rate:'',
  title_text:'',
  month_th: ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน ","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],
  month_th_abbreviation: ["ม.ค.","ก.พ.","มี.ค.","เม.ย","พ.ค.","มิ.ย. ","ก.ค.","ส.ค","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],
  prototype : {
    chart: {
        // type: 'cylinder',
        // options3d: {
        //   enabled: true,
        //   // alpha: 15,
        //   alpha: 10,
        //   // beta: 15,
        //   beta: 0,
        //   depth: 50,
        //   viewDistance: 0
        // },
        // height: 250
        type: 'spline',
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
        type: 'category',
        crosshair: true,
    },
    yAxis: {
        min: 0,
        title: {
            text: 'อัตราเฉลี่ย',
        },
        labels: {
          style: {
            fontSize: '6px'
          }
        }
    },
    tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: true,
        // valueDecimals: 2,
    },
    plotOptions: {
      //   spline: {
      //     // pointPadding: 0.2,
      //     // borderWidth: 0,
      //     allowPointSelect: false,
      //     cursor: 'pointer',
      //     dataLabels: {
      //         enabled: true,
      //         format: '{point.y}'
      //     },
      //     showInLegend: true
      // }
    },
    series: [{
        name: '',
        data: [],
        shared: true,
    }],
    exporting: {
      buttons: {
          contextButton:{
              menuItems: ["printChart", "downloadXLS"]
          }
      },
      chartOptions: {
        plotOptions: {
          //   spline: {
          //     pointWidth: 20,
          //     dataLabels: {
          //         enabled: false,
          //         style: {
          //             fontSize: '9px'
          //         }
          //     }
          // }
        },
        title: {
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            itemStyle: {
                fontSize: '9px'
            }
        },
        scale: 2
    }
  },
    credits: {
      enabled: false
    }
  },
  chart: {},
  showReport: false,
  chartresult: true
};
const actions = {
  async report_month({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.month).format('YYYY-MM-DD')
    let end = moment(data.type_data.month).add(1,'M')
        end = moment(end).subtract(1,'d')._d
        end = moment(end).format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    // data.date_range = !data.forecast ? data.daterange : false
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " +  data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" + technology_title+classify +
        " เดือน" + state.month_th[moment(data.type_data.month).month()] +
        " ปี พ.ศ. " + moment(data.type_data.month).add(543,'y').format("YYYY")
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" + technology_title+classify +
        " เดือน" + state.month_th[moment(data.type_data.month).month()] +
        " ปี พ.ศ. " + moment(data.type_data.month).add(543,'y').format("YYYY")
      }
      let left_title = "บาท / " + data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let temp = []
      let provider_name_list = []
      let month_amount = 0
      let average_list = []
      for (let date = moment(data.date_range.start)._d; date < moment(data.date_range.end)._d; date = moment(date).add(1, 'M')) {
        milestone.push(`${state.month_th_abbreviation[moment(date).month()]}-${moment(date).add(543,'y').format('YY')}`)
        month_amount += 1
        for (let provider of data.service_providers) {
          let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
          let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
          let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
          let temp_avg = 0
          let temp_amount = 0
          let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
          if(!provider_name_list.includes(name)) {
            provider_name_list.push(name)
          }
          for (let i = 0; i < month_data.length; i++) {
            temp_avg += month_data[i].internet_per_Mbps * service_rate
            temp_amount += month_data[i].total ? month_data[i].total : 0
          }
          if (temp[provider_name_list.indexOf(name)] == undefined) {
            console.log(temp_avg)
            temp.push({
              name: name,
              data: [temp_avg != 0 ? temp_avg : null],
              amount: [temp_amount],
              color: color
            })
          } else {
            temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
            temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
          }
        }
      }
      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp.length; i++) {
            temp_series.push({
              name: temp[i].name,
              data: temp[i].data.concat(forecast.data[i].data[0]),
              color: temp[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp.length; i++) {
            temp_series.push({
              name: temp[i].name,
              data: temp[i].data,
              color: temp[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        for (let i = 0; i < month_amount; i++) {
          let temp_total_avg = 0
          if (data.weighting && moment(moment(data.date_range.start)._d).year() > 2017) {
            temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
          } else {
            temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data[0] != null).length
          }
          average_list.push(temp_total_avg)
        }
        if (data.forecast) {
          milestone.push('forecast')
          average_list.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_list,
          color: '#4287f5',
          // pointPadding: 0.4
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      // MessageBox.confirm('No infomation hh', 'แจ้งเตือน', {
      //   confirmButtonText: 'OK',
      //   showCancelButton: false,
      //   type: 'warning'
      //   })
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_between_month({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    data.daterange = {
      start : moment(data.type_data.monthfrom).format('YYYY-MM-DD'),
      end : moment(data.type_data.monthto).add(1 ,'M').subtract(1, 'd').format('YYYY-MM-DD')
    }
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      state.showReport = true
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " + data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่"+technology_title+classify+
        " เดือน" +state.month_th[parseInt(moment(new Date(data.type_data.monthfrom)).format("MM"))-1] +
        " ปี พ.ศ. " +moment(new Date(data.type_data.monthfrom)).add(543,'y').format("YYYY") +
        " ถึงเดือน" +state.month_th[parseInt(moment(new Date(data.type_data.monthto)).format("MM")) - 1] +
        " ปี พ.ศ. " +moment(new Date(data.type_data.monthto)).add(543,'y').format("YYYY");
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่"+technology_title+classify+
        " เดือน" +state.month_th[parseInt(moment(new Date(data.type_data.monthfrom)).format("MM"))-1] +
        " ปี พ.ศ. " +moment(new Date(data.type_data.monthfrom)).add(543,'y').format("YYYY") +
        " ถึงเดือน" +state.month_th[parseInt(moment(new Date(data.type_data.monthto)).format("MM")) - 1] +
        " ปี พ.ศ. " +moment(new Date(data.type_data.monthto)).add(543,'y').format("YYYY");
      }
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let temp = []
      let provider_name_list = []
      let month_amount = []
      let average_list = []
      for (let date = moment(data.date_range.start)._d; date < moment(data.date_range.end)._d; date = moment(date).add(1, 'M')) {
        milestone.push(`${state.month_th_abbreviation[moment(date).month()]}-${moment(date).add(543,'y').format('YY')}`)
        month_amount.push(moment(date)._d)
        for (let provider of data.service_providers) {
          let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
          let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
          let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
          let temp_avg = 0
          let temp_amount = 0
          let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
          if(!provider_name_list.includes(name)) {
            provider_name_list.push(name)
          }
          for (let i = 0; i < month_data.length; i++) {
            temp_avg += month_data[i].internet_per_Mbps * service_rate
            temp_amount += month_data[i].total ? month_data[i].total : 0
          }
          // if (temp_amount > 0) {
          //   temp_avg = temp_avg/temp_amount
          // }
          if (temp[provider_name_list.indexOf(name)] == undefined) {
            temp.push({
              name: name,
              data: [temp_avg != 0 ? temp_avg : null],
              amount: [temp_amount],
              color: color
            })
          } else {
            temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
            temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
          }
        }
      }
      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp.length; i++) {
            temp_series.push({
              name: temp[i].name,
              data: temp[i].data.concat(forecast.data[i].data[0]),
              color: temp[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp.length; i++) {
            temp_series.push({
              name: temp[i].name,
              data: temp[i].data,
              color: temp[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        for (let i = 0; i < month_amount.length; i++) {
          let temp_total_avg = 0
          if (data.weighting && moment(month_amount[i]).year() > 2017) {
            temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
          } else {
            temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data[i] != null).length
          }
          average_list.push(temp_total_avg > 0 ? temp_total_avg : null)
        }
        if (data.forecast) {
          milestone.push('forecast')
          average_list.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_list,
          color: '#4287f5',
          // pointPadding: 0.2
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_year({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.year).format('YYYY-MM-DD')
    let end = moment(data.type_data.year).add(1,'Y')
        end = moment(end).subtract(1,'d')._d
        end = moment(end).format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      state.showReport = true
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " + data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ปี พ.ศ. "+moment(start).add(543,'y').format('YYYY')
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ปี พ.ศ. "+moment(start).add(543,'y').format('YYYY')
      }
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let average_year = []
      let temp_year = []
      let year_list = []
      for (let year = moment(data.date_range.start)._d; year < moment(data.date_range.end)._d; year = moment(year).add(1, 'Y')) {
        milestone.push(`พ.ศ. ${moment(year).add(543,'y').format('YYYY')}`)
        let temp = []
        let provider_name_list = []
        let month_amount = 0
        let average_list = []
        for (let date = moment(year)._d; date < moment(year).add(1, 'Y').subtract(1, 'd')._d; date = moment(date).add(1, 'M')) {
          month_amount += 1
          for (let provider of data.service_providers) {
            let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
            let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
            let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
            let temp_avg = 0
            let temp_amount = 0
            let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
            if(!provider_name_list.includes(name)) {
              provider_name_list.push(name)
            }
            for (let i = 0; i < month_data.length; i++) {
              temp_avg += month_data[i].internet_per_Mbps * service_rate
              temp_amount += month_data[i].total ? month_data[i].total : 0
            }
            // if (temp_amount > 0) {
            //   temp_avg = temp_avg/temp_amount
            // }
            if (temp[provider_name_list.indexOf(name)] == undefined) {
              temp.push({
                name: name,
                data: [temp_avg != 0 ? temp_avg : null],
                amount: [temp_amount],
                color: color
              })
            } else {
              temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
              temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
            }
          }
        }
        if (data.classify) {
          for(let i = 0; i < temp.length; i++) {
            if (!year_list.includes(temp[i].name)) {
              year_list.push(temp[i].name)
            }
            if (temp_year[year_list.indexOf(temp[i].name)] == undefined) {
              temp_year.push({
                name: temp[i].name,
                data: [temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.filter(avg => avg != null).length],
                color: temp[i].color
              })
            } else {
              temp_year[year_list.indexOf(temp[i].name)].data.push(temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.length)
            }
          }
        } else {
          for (let i = 0; i < temp[0].data.length; i++) {
            let temp_total_avg = 0
            if (data.weighting && moment(moment(year)._d).year() > 2017) {
              temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
            } else {
              temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data[i] != null).length
            }
            average_list.push(temp_total_avg > 0 ? temp_total_avg : null)
          }
          average_year.push(average_list.reduce((total, avg) => total + avg, 0) / average_list.filter(avg => avg != null).length)
        }
      }

      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp_year.length; i++) {
            temp_series.push({
              name: temp_year[i].name,
              data: temp_year[i].data.concat(forecast.data[i].data[0]),
              color: temp_year[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp_year.length; i++) {
            temp_series.push({
              name: temp_year[i].name,
              data: temp_year[i].data,
              color: temp_year[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        if (data.forecast) {
          milestone.push('forecast')
          average_year.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_year,
          color: '#4287f5',
          // pointPadding: 0.4
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_between_year({ commit }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.yearfrom).format('YYYY-MM-DD')
    let end = moment(data.type_data.yearto).add(1,'Y')
        end = moment(end).subtract(1,'d').format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      state.showReport = true
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " +  data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ระหว่างปี พ.ศ. "+moment(start).add(543,'y').format('YYYY')+' ถึงปี พ.ศ. '+moment(end).add(543,'y').format('YYYY')
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ระหว่างปี พ.ศ. "+moment(start).add(543,'y').format('YYYY')+' ถึงปี พ.ศ. '+moment(end).add(543,'y').format('YYYY')
      }
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let average_year = []
      let temp_year = []
      let year_list = []
      for (let year = moment(data.date_range.start)._d; year < moment(data.date_range.end)._d; year = moment(year).add(1, 'Y')) {
        milestone.push(`พ.ศ. ${moment(year).add(543,'y').format('YYYY')}`)
        let temp = []
        let provider_name_list = []
        let month_amount = 0
        let average_list = []
        for (let date = moment(year)._d; date < moment(year).add(1, 'Y').subtract(1, 'd')._d; date = moment(date).add(1, 'M')) {
          month_amount += 1
          for (let provider of data.service_providers) {
            let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
            let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
            let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
            let temp_avg = 0
            let temp_amount = 0
            let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
            if(!provider_name_list.includes(name)) {
              provider_name_list.push(name)
            }
            for (let i = 0; i < month_data.length; i++) {
              temp_avg += month_data[i].internet_per_Mbps * service_rate
              temp_amount += month_data[i].total ? month_data[i].total : 0
            }
            // if (temp_amount > 0) {
            //   temp_avg = temp_avg/temp_amount
            // }
            if (temp[provider_name_list.indexOf(name)] == undefined) {
              temp.push({
                name: name,
                data: [temp_avg != 0 ? temp_avg : null],
                amount: [temp_amount],
                color: color
              })
            } else {
              temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
              temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
            }
          }
        }
        if (data.classify) {
          for(let i = 0; i < temp.length; i++) {
            if (!year_list.includes(temp[i].name)) {
              year_list.push(temp[i].name)
            }
            let temp_data = temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.filter(avg => avg != null).length
            if (temp_year[year_list.indexOf(temp[i].name)] == undefined) {
              temp_year.push({
                name: temp[i].name,
                data: [temp_data != 0 ? temp_data : null],
                color: temp[i].color
              })
            } else {
              temp_year[year_list.indexOf(temp[i].name)].data.push(temp_data != 0 ? temp_data : null)
            }
          }
        } else {
          for (let i = 0; i < month_amount; i++) {
            let temp_total_avg = 0
            if (data.weighting && moment(moment(year)._d).year() > 2017) {
              temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
            } else {
              // temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data.some((value)=> {return value > 0})).length 
              temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data[i] != null).length
            }
            average_list.push(temp_total_avg == NaN || temp_total_avg == 0 || temp_total_avg == null ? null : temp_total_avg)
          }
          let temp_data = average_list.reduce((total, avg) => total + (avg > 0 ? avg : 0), 0) / average_list.filter(avg => avg > 0).length
          average_year.push(temp_data != 0 ? temp_data : null)
        }
      }

      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp_year.length; i++) {
            temp_series.push({
              name: temp_year[i].name,
              data: temp_year[i].data.concat(forecast.data[i].data[0]),
              color: temp_year[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp_year.length; i++) {
            temp_series.push({
              name: temp_year[i].name,
              data: temp_year[i].data,
              color: temp_year[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        if (data.forecast) {
          milestone.push('forecast')
          average_year.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_year,
          color: '#4287f5',
          // pointPadding: 0.2
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_quarter({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.quarter_year).add((data.type_data.quarter-1)*3,'M').format('YYYY-MM-DD')
    let end = moment(start).add(3,'M')
        end = moment(end).subtract(1,'d').format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      state.showReport = true
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " +  data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ไตรมาสที่ "+data.type_data.quarter+" ปี พ.ศ. "+moment(data.type_data.quarter_year).add(543,'y').format('YYYY')
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ไตรมาสที่ "+data.type_data.quarter+" ปี พ.ศ. "+moment(data.type_data.quarter_year).add(543,'y').format('YYYY')
      }
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let average_quarter = []
      let temp_quarter = []
      let quarter_list = []
      for (let quarter = moment(data.date_range.start)._d; quarter < moment(data.date_range.end)._d; quarter = moment(quarter).add(3, 'M')) {
        milestone.push(`${moment(quarter).quarter()}Q${moment(quarter).add(543,'y').format('YYYY')}`)
        let temp = []
        let provider_name_list = []
        let month_amount = 0
        let average_list = []
        for (let date = moment(quarter)._d; date < moment(quarter).add(3, 'M').subtract(1, 'd')._d; date = moment(date).add(1, 'M')) {
          month_amount += 1
          for (let provider of data.service_providers) {
            let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
            let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
            let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
            let temp_avg = 0
            let temp_amount = 0
            let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
            if(!provider_name_list.includes(name)) {
              provider_name_list.push(name)
            }
            for (let i = 0; i < month_data.length; i++) {
              temp_avg += month_data[i].internet_per_Mbps * service_rate
              temp_amount += month_data[i].total ? month_data[i].total : 0
            }
            // if (temp_amount > 0) {
            //   temp_avg = temp_avg/temp_amount
            // }
            if (temp[provider_name_list.indexOf(name)] == undefined) {
              temp.push({
                name: name,
                data: [temp_avg != 0 ? temp_avg : null],
                amount: [temp_amount],
                color: color
              })
            } else {
              temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
              temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
            }
          }
        }
        if (data.classify) {
          for(let i = 0; i < temp.length; i++) {
            if (!quarter_list.includes(temp[i].name)) {
              quarter_list.push(temp[i].name)
            }
            if (temp_quarter[quarter_list.indexOf(temp[i].name)] == undefined) {
              temp_quarter.push({
                name: temp[i].name,
                data: [temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.length],
                color: temp[i].color
              })
            } else {
              temp_quarter[quarter_list.indexOf(temp[i].name)].data.push(temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.length)
            }
          }
        } else {
          for (let i = 0; i < month_amount; i++) {
            let temp_total_avg = 0
            if (data.weighting && moment(data.date_range.start).year() > 2017) {
              temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
            } else {
              temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data[0] != null).length
            }
            average_list.push(temp_total_avg > 0 ? temp_total_avg : null)
          }
          average_quarter.push(average_list.reduce((total, avg) => total + avg, 0) / average_list.length)
        }
      }

      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp_quarter.length; i++) {
            console.log(temp_quarter[i].data)
            temp_series.push({
              name: temp_quarter[i].name,
              data: temp_quarter[i].data.concat(forecast.data[i].data[0]),
              color: temp_quarter[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp_quarter.length; i++) {
            temp_series.push({
              name: temp_quarter[i].name,
              data: temp_quarter[i].data.length != 0 ? temp_quarter[i].data.map(avg => avg > 0 ? avg : null) : null,
              color: temp_quarter[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        if (data.forecast) {
          milestone.push('forecast')
          average_quarter.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_quarter,
          color: '#4287f5',
          // pointPadding: 0.4
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_between_quarter({ commit }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.quarter_year_from).add((data.type_data.quarterfrom-1)*3,'M').format('YYYY-MM-DD')
    let end = moment(data.type_data.quarter_year).add(data.type_data.quarterto*3,'M')
        end = moment(end).subtract(1,'d').format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.date_range = data.daterange
    if(data.classify) data.weighting = false
    let result = await Report_G11_service.getBroadbandAvgAll(data)
    let forecast = await Report_G11_service.getBroadbandForecast(data)
    if(result.status === 200 && result.data.length !== 0){
      state.showReport = true
      let classify = data.classify ? " จำแนกตามผู้ให้บริการ" : ""
      let technology_title = data.promotion_technology ? "จำแนกตามเทคโนโลยี " +  data.promotion_technology : ""
      let top_title = ""
      if (data.weighting && data.classify != 1) {
        top_title = "อัตราค่าบริการเฉลี่ยแบบถ่วงน้ำหนักของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ไตรมาสที่ "+data.type_data.quarterfrom+" ปี พ.ศ. "+moment(data.type_data.quarter_year_from).add(543,'y').format('YYYY') +" ถึงไตรมาสที่ "+data.type_data.quarterto+" ปี พ.ศ. "+moment(data.type_data.quarter_year).add(543,'y').format('YYYY') 
      } else {
        top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+classify+" ไตรมาสที่ "+data.type_data.quarterfrom+" ปี พ.ศ. "+moment(data.type_data.quarter_year_from).add(543,'y').format('YYYY') +" ถึงไตรมาสที่ "+data.type_data.quarterto+" ปี พ.ศ. "+moment(data.type_data.quarter_year).add(543,'y').format('YYYY') 
      }
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let series = []
      let rowdata = result.data
      let average_quarter = []
      let temp_quarter = []
      let quarter_list = []
      for (let quarter = moment(data.date_range.start)._d; quarter < moment(data.date_range.end)._d; quarter = moment(quarter).add(3, 'M')) {
        milestone.push(`${moment(quarter).quarter()}Q${moment(quarter).add(543,'y').format('YYYY')}`)
        let temp = []
        let provider_name_list = []
        let month_amount = 0
        let average_list = []
        for (let date = moment(quarter)._d; date < moment(quarter).add(3, 'M').subtract(1, 'd')._d; date = moment(date).add(1, 'M')) {
          month_amount += 1
          for (let provider of data.service_providers) {
            let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
            let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
            let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
            let temp_avg = 0
            let temp_amount = 0
            let month_data = rowdata.filter(data => moment(data.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD') && item_group.includes(data.provider_id))
            if(!provider_name_list.includes(name)) {
              provider_name_list.push(name)
            }
            for (let i = 0; i < month_data.length; i++) {
              temp_avg += month_data[i].internet_per_Mbps * service_rate
              temp_amount += month_data[i].total ? month_data[i].total : 0
            }
            // if (temp_amount > 0) {
            //   temp_avg = temp_avg/temp_amount
            // }
            if (temp[provider_name_list.indexOf(name)] == undefined) {
              temp.push({
                name: name,
                data: [temp_avg != 0 ? temp_avg : null],
                amount: [temp_amount],
                color: color
              })
            } else {
              temp[provider_name_list.indexOf(name)].data.push(temp_avg != 0 ? temp_avg : null)
              temp[provider_name_list.indexOf(name)].amount.push(temp_amount)
            }
          }
        }
        if (data.classify) {
          for(let i = 0; i < temp.length; i++) {
            if (!quarter_list.includes(temp[i].name)) {
              quarter_list.push(temp[i].name)
            }
            let temp_data = temp[i].data.reduce((total, data) => total + data, 0)/temp[i].data.length
            if (temp_quarter[quarter_list.indexOf(temp[i].name)] == undefined) {
              temp_quarter.push({
                name: temp[i].name,
                data: [temp_data != 0 ? temp_data : null],
                color: temp[i].color
              })
            } else {
              temp_quarter[quarter_list.indexOf(temp[i].name)].data.push(temp_data != 0 ? temp_data : null)
            }
          }
        } else {
          for (let i = 0; i < month_amount; i++) {
            let temp_total_avg = 0
            if (data.weighting && moment(moment(quarter)._d).year() > 2017) {
              temp_total_avg = temp.reduce((total, avg) => total + (avg.data[i] * avg.amount[i]), 0)/temp.reduce((total, avg) => total + avg.amount[i], 0)
            } else {
              temp_total_avg = temp.reduce((total, avg) => total + avg.data[i], 0)/temp.filter(provider => provider.data.some((value) => { return value != null })).length
            }
            average_list.push(temp_total_avg == NaN || temp_total_avg == 0 || temp_total_avg == null ? null : temp_total_avg)
          }
          let temp_data = average_list.reduce((total, avg) => total + (avg > 0 ? avg : 0), 0) / average_list.filter(avg => avg > 0).length
          average_quarter.push(temp_data != 0 ? temp_data : null)
        }
      }

      if (data.classify) {
        let temp_series = []
        if (data.forecast) {
          milestone.push('forecast')
          for (let i = 0; i < temp_quarter.length; i++) {
            temp_series.push({
              name: temp_quarter[i].name,
              data: temp_quarter[i].data.concat(forecast.data[i].data[0]),
              color: temp_quarter[i].color,
              // pointPadding: 0.2
            })
          }
        } else {
          for (let i = 0; i < temp_quarter.length; i++) {
            temp_series.push({
              name: temp_quarter[i].name,
              data: temp_quarter[i].data,
              color: temp_quarter[i].color,
              // pointPadding: 0.2
            })
          }
        }
        series = temp_series
      } else {
        if (data.forecast) {
          milestone.push('forecast')
          average_quarter.push(forecast.data[0].data[0])
        }
        series.push({
          name: 'อัตราค่าเฉลี่ย',
          data: average_quarter,
          color: '#4287f5',
          // pointPadding: 0.2
        })
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        steps : steps
      }
      commit('SET_DATA_CHART',obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }else{
      state.showReport = false
      state.chartresult = false
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async resetDisplay({commit}) {
    commit('RESET_DISPLAY')
  }
};

const mutations = {
  RESET_DISPLAY(state) {
    state.showReport = false
  },
  SET_DATA_CHART(state, data){
    let chart = JSON.parse(JSON.stringify(state.prototype))
    chart.title.text = data.top_title
    chart.yAxis.title.text = data.left_title
    chart.xAxis.categories = data.milestone
    chart.series = data.series
    chart.tooltip = {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.' + data.steps + 'f}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    }
    chart.plotOptions = {
      series: {
        groupPadding: 0.1
      },
      // spline: {
      //   dataLabels: {
      //     enabled: true,
      //     overflow: "allow",
      //     crop: false,
      //     allowOverlap: true,
      //     rotation: 270,
      //     align: 'left',
      //     y: -5,
      //     formatter: function() {
      //       return this.y.toFixed(data.steps)
      //     },
      //     style: {
      //       fontWeight: 'thin',
      //       fontSize: '3px'
      //     }
      //   }
      // }
    }
    chart.exporting = {
      showTable: false,
      buttons: {
        contextButton:{
          // menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
          menuItems: ["printChart", "downloadXLS"]
        }
      },
      csv: {
          columnHeaderFormatter: function(item, point) {
              if (!item || item.coll == "xAxis") {
                  return 'ช่วงเวลา'
              } else {
                  return {
                    topLevelColumnTitle: data.steps == 2 ? 'บาท/Mbps' : 'บาท/Kbps',
                    columnTitle: point === 'y' ? item.name : point
                  };
              }
          }
      },
      chartOptions: {
        plotOptions: {
          //   spline: {
          //     dataLabels: {
          //         enabled: true,
          //         style: {
          //             fontSize: '8px',
          //             fontWeight: 'thin'
          //         }
          //     }
          // }
        },
        title: {
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            itemStyle: {
                fontSize: '9px'
            }
        },
        scale: 2,
        chart: {
          height: 400,
          width: 1920
        },
        sourceHeight: 400,
        sourceWidth: 1920
      },
      allowHTML: true
    }
    chart.decimal = data.steps
    state.chart = chart
    state.showReport = true
  }
}

function array_average_data(arr) {
  const count = arr[0].map(()=> 0)
  let result = arr.reduce((acc, item, index)=> {
    return item.map((val, i)=> {
        count[i] = index != 0?(val == null? count[i]: count[i]+1):(val == null? 0: count[i]+1)
        return index == 0? val: (index == (arr.length-1)? (count[i] == 0? null:((acc[i] || 0) + val)/count[i]):((acc[i] || 0) + val))
      })
    },[])
  return result
}
function formatNumber(num) {
  if (num >= 10) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else if( num < 1 ) {
    return num;
  }
  return num.toFixed(2);
}
export const Report_G11 = {
  namespaced: true,
  state,
  actions,
  mutations
};
